const fold = (text: string) =>
	text
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase();

export function filterOptions<T extends { name: string }>(options: T[], query: string): T[] {
	const needle = fold(query.trim());
	if (!needle) {
		return options;
	}
	return options.filter((option) => fold(option.name).includes(needle));
}
